import { Helmet } from 'react-helmet-async';
import { faker } from '@faker-js/faker';
// @mui
import { useTheme } from '@mui/material/styles';
import { Grid, Container, TableCell, Card, TableContainer, Stack, Avatar, Typography, FormControl, Select, MenuItem, Button, Dialog, DialogTitle, DialogContent, TextField, Tooltip, CardMedia, CardContent, Stepper, Box, Paper, StepLabel, Step, Chip } from '@mui/material';
// sections
import { AppOrderTimeline, AppCurrentVisits, AppWebsiteVisits, AppWidgetSummary } from '../sections/@dashboard/app';
import { useEffect, useState } from 'react';
import { formPostData, getData, postData } from 'src/webService/webService';
import { toast, ToastContainer } from 'react-toastify';
import Iconify from 'src/components/iconify';
import whatsappIcon from 'src/components/icons/whatsapp (1).png';
import { useNavigate } from 'react-router-dom';
import uploadIcon from '../components/images/upload-placeholder.webp';

// ----------------------------------------------------------------------

export default function DashboardAppPage() {
  const theme = useTheme();
  const Token = sessionStorage.getItem('Token');
  const [getHistory, setGetHistory] = useState([]);
  const [callRequest, setCallRequest] = useState([]);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1)
  const [TotalItems, setTotalItems] = useState(null);
  const [limitRequest, setLimitRequest] = useState(10);
  const [currentPageRequest, setCurrentPageRequest] = useState(1);
  const [totalPagesRequest, setTotalPagesRequest] = useState(1)
  const [TotalItemsRequest, setTotalItemsRequest] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [report, setReport] = useState('');
  const [buyerId, setBuyerId] = useState('');
  const role = sessionStorage.getItem('Role');
  const [getAnalysisData, setGetAnalysisData] = useState({});
  const [video, setVideo] = useState(false);
  const [previewVideo, setPreviewVideo] = useState(null)
  const [activeStep, setActiveStep] = useState(() => {
    const savedStep = sessionStorage.getItem('activeStep');
    return savedStep !== null ? parseInt(savedStep, 10) : 0;
  });
  const [brandPendingStatus, setBrandPendingStatus] = useState(false);
  const [availableBrands, setAvailableBrands] = useState(null);
  const [addVideoOpen, setAddVideoOpen] = useState(false);
  const [previewUploadedVideo, setPreviewUploadedVideo] = useState(null);
  const [profileIntroVideo, setProfileIntroVideo] = useState(null);
  const [selectedBrandId, setSelectedBrandId] = useState(null);
  const [brandList, setBrandList] = useState([]);
  const [brandName, setbrandName] = useState('');

  const navigate = useNavigate();

  useEffect(() => {
    const savedStep = sessionStorage.getItem('activeStep');
    if (savedStep !== null) {
      setActiveStep(JSON.parse(savedStep));
    }
  }, []);

  useEffect(() => {
    sessionStorage.setItem('activeStep', activeStep.toString());
  }, [activeStep]);

  const handleLimitChange = (event) => {
    setCurrentPage(1);
    setLimit(event.target.value);
  };

  console.log(currentPageRequest, 'currentpagerequest');

  const playVideo = (id) => {
    debugger;
    // setPreviewVideo(id);
    getBrandsById(id)
    setVideo(true);
  };
  const handleCloseVideo = () => {
    setVideo(false);
    setPreviewVideo(null);
  }

  const handleAddVideoOpen = (id) => {
    setSelectedBrandId(id);
    setAddVideoOpen(true);
  }

  const handleAddVideoClose = () => {
    setAddVideoOpen(false);
  }
  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handleOpenModal = (id) => {
    setOpenModal(true);
    setBuyerId(id);
  }

  const handleClose = () => {
    setOpenModal(false);
  }

  const handleLimitChangeRequest = (event) => {
    setCurrentPageRequest(1);
    setLimitRequest(event.target.value);
  };

  const handlePrevPageRequest = () => {
    if (currentPageRequest > 1) {
      setCurrentPageRequest(currentPageRequest - 1);
    }
  };

  const handleNextPageRequest = () => {
    if (currentPageRequest < totalPagesRequest) {
      setCurrentPageRequest(currentPage + 1);
    }
  };

  const getAnalysis = async (id) => {
    try {
      if (role === 'Admin') {
        const res = await getData('analytics', null, Token);
        if (res.status === 200) {
          console.log(res, "res.data");
          setGetAnalysisData(res);
        }
      } else if (role === 'Seller') {
        const res = await getData(`seller/${id}/analytics`, null, Token);
        if (res.status === 200) {
          console.log(res, "res.data");
          setGetAnalysisData(res);
        }
      }

    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred. Please try again later.", {});
    }
  }

  const getHistoryData = async (page, brandId) => {
    const params = {
      page: page,
      per_page: limit,
    }
    try {
      const res = await getData(`seller/${brandId}/history`, params, Token);
      if (res.status === 200) {
        console.log(res.data, "res.data");
        setGetHistory(res?.data);
        setTotalItems(res?.total);
        setTotalPages(res?.last_page);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred. Please try again later.", {});
    }
  }

  const postReport = () => {
    debugger;
    const params = {
      reason: report
    }

    postData(`seller/report/${buyerId}`, params, Token)
      .then((res) => {
        toast.success(res?.message);
        setGetHistory(currentPage);
        getCallRequestData(currentPageRequest);
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error(error);
      });

    handleClose();
  }

  const getCallRequestData = async (page, brandId) => {
    debugger;
    const params = {
      page: page,
      per_page: limitRequest,
    }
    try {
      const res = await getData(`seller/${brandId}/requests`, params, Token);
      if (res.status === 200) {
        console.log(res.data, "res.data");
        setCallRequest(res?.data);
        setTotalItemsRequest(res?.total);
        setTotalPagesRequest(res?.last_page);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred. Please try again later.", {});
    }
  }

  useEffect(() => {
    if (role === 'Seller' && activeStep === 2) {
      getCallRequestData(currentPageRequest);
    }
  }, [limitRequest, role, currentPageRequest]);

  useEffect(() => {
    if (role === 'Seller' && activeStep === 1) {
      getHistoryData(currentPage);
    }
  }, [limit, role, currentPage]);

  const getBrandList = async (page) => {
    const params = {
      page: page,
      per_page: limit,
    }
    try {
      const res = await getData('seller/brand', params, Token);
      if (res.status === 200) {
        setBrandList(res.data);
        setBrandPendingStatus(res.pending_brand_setup);
        setAvailableBrands(res.available_brands);
        // setPreviewVideo(res.data.intro_video);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred. Please try again later.", {});
    }
  }

  const getBrandsById = async (id) => {
    debugger
    try {
      const res = await getData(`seller/brand/${id}`, null, Token);
      if (res.status === 200) {
        setPreviewVideo(res.intro_video);
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("An error occurred. Please try again later.", {});
    }
  }

  useEffect(() => {
    if (role === 'Seller') {
      getBrandList();
    }
  }, [])

  const goToBrand = () => {
    navigate('/seller/brands')
  }

  const handleGoToDashboard = (e, brand, newValue) => {
    setActiveStep(1);
    navigate(`/seller/brand/analytics/${brand?._id}/${brand?.name}`)
    getAnalysis();
  };

  const handleBackToDashboard = () => {
    setActiveStep(0)
    sessionStorage.setItem('showProduct', 'false')
  }

  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const videoURL = URL.createObjectURL(file);
      setPreviewUploadedVideo(videoURL);
      setProfileIntroVideo(file);
    }
  };

  const handleSubmit = (e) => {
    debugger
    e.preventDefault();

    const formDataToSend = new FormData();

    formDataToSend.append("intro_video", profileIntroVideo);

    formDataToSend.append("_method", "PUT");

    formPostData(`seller/brand/${selectedBrandId}`, formDataToSend, Token)
      .then((res) => {

        toast.success('Intro Video uploaded successfully');
        handleAddVideoClose();
        setPreviewUploadedVideo(uploadIcon);
        setProfileIntroVideo(null);
        getBrandList()
      })
      .catch((error) => {
        console.error("Error:", error);
        toast.error("Error submitting brand");
      });
  };

  useEffect(()=>{
    if (role === "Admin"){
      getAnalysis();
    }
  },[])

  return (
    <>
      <ToastContainer position='top-right' />
      <Helmet>
        <title> Dashboard </title>
      </Helmet>
      {role === "Admin" && (
        <>
          <div className='AdminDash' maxWidth="xl">
            <Grid container spacing={3}>
              <Grid item xs={12} md={6} lg={3}>
                <div className='dashboardCard'>
                  <p className='fs-14 mb-2 d-flex align-items-center'><Iconify style={{ marginRight: '10px' }} icon="eva:cube-outline" />Total Views</p>
                  <h4>{getAnalysisData?.views ? getAnalysisData?.views : 0}</h4>
                  <p className='fs-14 mb-0'><b>{getAnalysisData?.recent_views ? getAnalysisData?.recent_views : 0}</b> Views in last 7 days</p>
                </div>
              </Grid>

              <Grid item xs={12} md={6} lg={3}>
                <div className='dashboardCard'>
                  <p className='fs-14 mb-2 d-flex align-items-center'><Iconify style={{ marginRight: '10px' }} icon="eva:phone-outline" />Total Calls</p>
                  <h4>{getAnalysisData?.calls ? getAnalysisData?.calls : 0}</h4>
                  <p className='fs-14 mb-0'><b>{getAnalysisData?.recent_calls ? getAnalysisData?.recent_calls : 0}</b> Calls in last 7 days</p>
                </div>
              </Grid>

              <Grid item xs={12} md={6} lg={3}>
                <div className='dashboardCard'>
                  <p className='fs-14 mb-2 d-flex align-items-center'><Iconify style={{ marginRight: '10px' }} icon="eva:message-square-outline" />Total Chat</p>
                  <h4>{getAnalysisData?.chats ? getAnalysisData?.chats : 0}</h4>
                  <p className='fs-14 mb-0'><b>{getAnalysisData?.recent_chats ? getAnalysisData?.recent_chats : 0}</b> Chats in last 7 days</p>
                </div>
              </Grid>

              <Grid item xs={12} md={6} lg={3}>
                <div className='dashboardCard'>
                  <p className='fs-14 mb-2 d-flex align-items-center'><Iconify style={{ marginRight: '10px' }} icon="eva:phone-outline" />Total Callback Request</p>
                  <h4>{getAnalysisData?.callback_requests ? getAnalysisData?.callback_requests : 0}</h4>
                  <p className='fs-14 mb-0'><b>{getAnalysisData?.recent_callback_requests ? getAnalysisData?.recent_callback_requests : 0}</b> Callback in last 7 days</p>
                </div>
              </Grid>

              {role === 'Admin' ? (
                <Grid item xs={12} md={6} lg={3}>
                  <div className='dashboardCard'>
                    <p className='fs-14 mb-2 d-flex align-items-center'><Iconify style={{ marginRight: '10px' }} icon="eva:car-outline" />Total Seller</p>
                    <h4>{getAnalysisData?.sellers ? getAnalysisData?.sellers : 0}</h4>
                    <p className='fs-14 mb-0'><b>{getAnalysisData?.recent_sellers ? getAnalysisData?.recent_sellers : 0}</b> Seller in last 7 days</p>
                  </div>
                </Grid>

              ) : (
                <></>
              )}

              {role === 'Admin' ? (
                <Grid item xs={12} md={6} lg={3}>
                  <div className='dashboardCard'>
                    <p className='fs-14 mb-2 d-flex align-items-center'><Iconify style={{ marginRight: '10px' }} icon="eva:shopping-cart-outline" />Total Buyer</p>
                    <h4>{getAnalysisData?.buyers ? getAnalysisData?.buyers : 0}</h4>
                    <p className='fs-14 mb-0'><b>{getAnalysisData?.recent_buyers ? getAnalysisData?.recent_buyers : 0}</b> Buyers in last 7 days</p>
                  </div>
                </Grid>
              ) : (
                <></>
              )}

              {role === 'Admin' ? (
                <Grid item xs={12} md={6} lg={3}>
                  <div className='dashboardCard'>
                    <p className='fs-14 mb-2 d-flex align-items-center'><Iconify style={{ marginRight: '10px' }} icon="eva:grid-outline" />Total Categories</p>
                    <h4>{getAnalysisData?.categories ? getAnalysisData?.categories : 0}</h4>
                    {/* <p className='fs-14 mb-0'>{getAnalysisData?.recent_callback_requests} Callback vs 6 days before </p> */}
                  </div>
                </Grid>
              ) : (
                <></>
              )}

              {role === 'Admin' ? (
                <Grid item xs={12} md={6} lg={3}>
                  <div className='dashboardCard'>
                    <p className='fs-14 mb-2 d-flex align-items-center'><Iconify style={{ marginRight: '10px' }} icon="eva:cube-outline" />Total Products</p>
                    <h4>{getAnalysisData?.products ? getAnalysisData?.products : 0}</h4>
                    <p className='fs-14 mb-0'><b>{getAnalysisData?.recent_products ? getAnalysisData?.recent_products : 0}</b> Product in last 7 days</p>
                  </div>
                </Grid>
              ) : <></>}

              {role === 'Admin' ? (
                <Grid item xs={12} md={6} lg={3}>
                  <div className='dashboardCard'>
                    <p className='fs-14 mb-2 d-flex align-items-center'><Iconify style={{ marginRight: '10px' }} icon="mdi:tag" />Total Brands</p>
                    <h4>{getAnalysisData?.brands ? getAnalysisData?.brands : 0}</h4>
                    <p className='fs-14 mb-0'><b>{getAnalysisData?.recent_brands ? getAnalysisData?.recent_brands : 0}</b> Brands in last 7 days</p>
                  </div>
                </Grid>
              ) : <></>}

              {role === 'Admin' ? (
                <></>
              ) : (

                <Grid item xs={12} md={6} lg={6}>
                  <Card>
                    <Stack className='mb-0 pt-4' paddingLeft='20px' direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                      <Typography variant="h6" style={{ fontSize: '1rem' }} className='title-color' gutterBottom>
                        History
                      </Typography>
                    </Stack>
                    <TableContainer style={{ height: "361px", overflowY: "scroll", width: "100%", padding: '20px' }}>
                      {getHistory?.map((item, index) => (
                        <div className="p-2 mb-3 profileCard">
                          <div className='row'>
                            <div className='col-lg-2'>
                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={2}
                              >
                                {item?.buyer?.profile_picture ? (
                                  <Avatar style={{ width: '60px', height: '60px' }} src={item?.buyer?.profile_picture}></Avatar>
                                ) : (
                                  <Avatar style={{ width: '60px', height: '60px' }}>
                                    {item?.buyer?.name
                                      ? item?.buyer?.name[0]
                                      : null}
                                  </Avatar>
                                )}
                              </Stack>
                            </div>
                            <div className='col-lg-6 d-flex align-items-center'>
                              <div>
                                <h6 className='d-flex align-items-center'>{item?.buyer?.name}<Tooltip title="Report" arrow><Iconify style={{ marginLeft: '10px', color: 'red' }} className='pointer' onClick={(e) => handleOpenModal(item?.buyer?._id)} icon="eva:alert-circle-outline" /></Tooltip></h6>
                                <p className='fs-14 mb-0'>{item?.buyer?.location}</p>
                              </div>
                            </div>

                            <div className='col-lg-4 d-flex align-items-center justify-content-center'>
                              <div>
                                <p className='fs-14 mb-0'>Type: <b>{item?.type}</b></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </TableContainer>
                    <div className="d-flex flex-wrap justify-content-end m-3">
                      <FormControl variant="outlined" size="small" style={{ width: "15%" }}>
                        <Select
                          labelId="limit-label"
                          id="limit-select"
                          value={limit}
                          onChange={handleLimitChange}
                        >
                          <MenuItem value={10}>10</MenuItem>
                          <MenuItem value={20}>20</MenuItem>
                          <MenuItem value={30}>30</MenuItem>
                          <MenuItem value={TotalItems}>All</MenuItem>
                        </Select>
                      </FormControl>
                      <Button onClick={handlePrevPage} disabled={currentPage === 1}>
                        <Iconify icon={"grommet-icons:previous"} />
                      </Button>
                      <Button
                        onClick={handleNextPage}
                        disabled={currentPage === totalPages}
                      >
                        <Iconify icon={"grommet-icons:next"} />
                      </Button>
                    </div>
                  </Card>
                </Grid>
              )}

              {role === 'Admin' ? (
                <></>
              ) : (
                <Grid item xs={12} md={6} lg={6}>
                  <Card>
                    <Stack className='mb-0 pt-4' paddingLeft='20px' direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                      <Typography variant="h6" className='title-color' style={{ fontSize: '1rem' }} gutterBottom>
                        Call Requests
                      </Typography>
                    </Stack>
                    <TableContainer style={{ height: "361px", overflowY: "scroll", width: "100%", padding: '20px' }}>
                      {callRequest?.map((item, index) => (
                        <div className="p-2 mb-3 profileCard">
                          <div className='row'>
                            <div className='col-lg-2'>
                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={2}
                              >
                                {item?.buyer?.profile_picture ? (
                                  <Avatar style={{ width: '60px', height: '60px' }} src={item?.buyer?.profile_picture}></Avatar>
                                ) : (
                                  <Avatar style={{ width: '60px', height: '60px' }}>
                                    {item?.buyer?.name
                                      ? item?.buyer?.name[0]
                                      : null}
                                  </Avatar>
                                )}
                              </Stack>
                            </div>
                            <div className='col-lg-5 d-flex align-items-center'>
                              <div>
                                <h6 className='d-flex align-items-center'>{item?.buyer?.name ? item?.buyer?.name : 'Name Not Available'}<Tooltip title="Report" arrow><Iconify style={{ marginLeft: '10px', color: 'red' }} onClick={(e) => handleOpenModal(item?.buyer?._id)} className='pointer' icon="eva:alert-circle-outline" /></Tooltip></h6>
                                <p className='fs-14 mb-0'>{item?.buyer?.location ? item?.buyer?.location : 'Location Not Available'}</p>
                              </div>
                            </div>

                            <div className='col-lg-5 d-flex align-items-center justify-content-center'>
                              <div>
                                <a href={`tel:${item?.buyer?.phone}`} style={{ textDecoration: 'none', color: '#212B36' }}>
                                  <p className='fs-14 mb-2'><Iconify style={{ marginRight: '12px' }} icon={"eva:phone-outline"} /><b> {item?.buyer?.phone ? item?.buyer?.phone : 'Not Available'}</b></p>
                                </a>
                                <a
                                  href={`https://wa.me/${item?.buyer?.whatsapp}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ textDecoration: 'none', color: '#212B36' }}
                                >
                                  <p className="fs-14 d-flex align-items-center mb-0"><img style={{ marginRight: '14px', width: '11%' }} src={whatsappIcon} /><b>{item?.buyer?.whatsapp ? item?.buyer?.whatsapp : 'Not Available'}</b></p>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </TableContainer>
                    <div className="d-flex flex-wrap justify-content-end m-3">
                      <FormControl variant="outlined" size="small" style={{ width: "15%" }}>
                        <Select
                          labelId="limit-label"
                          id="limit-select"
                          value={limitRequest}
                          onChange={handleLimitChangeRequest}
                        >
                          <MenuItem value={10}>10</MenuItem>
                          <MenuItem value={20}>20</MenuItem>
                          <MenuItem value={30}>30</MenuItem>
                          <MenuItem value={TotalItemsRequest}>All</MenuItem>
                        </Select>
                      </FormControl>
                      <Button onClick={handlePrevPageRequest} disabled={currentPageRequest === 1}>
                        <Iconify icon={"grommet-icons:previous"} />
                      </Button>
                      <Button
                        onClick={handleNextPageRequest}
                        disabled={currentPageRequest === totalPagesRequest}
                      >
                        <Iconify icon={"grommet-icons:next"} />
                      </Button>
                    </div>
                  </Card>
                </Grid>
              )}


              {/* <Grid item xs={12} md={6} lg={6}>
            <AppOrderTimeline
              title="Order Timeline"
              list={[...Array(5)].map((_, index) => ({
                id: faker.datatype.uuid(),
                title: [
                  '1983, orders, $4220',
                  '12 Invoices have been paid',
                  'Order #37745 from September',
                  'New order placed #XF-2356',
                  'New order placed #XF-2346',
                ][index],
                type: `order${index + 1}`,
                time: faker.date.past(),
              }))}
            />
          </Grid> */}
            </Grid>
          </div>

          <Dialog open={openModal} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Report Buyer</DialogTitle>
            <DialogContent>
              <Grid item xs={12} className='mt-3'>
                <TextField
                  className="w-100"
                  id="outlined-basic"
                  value={report}
                  onChange={(e) => setReport(e.target.value)}
                  label="Report *"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <div className='mt-4 d-flex justify-content-end'>
                <Button variant="contained" className='Button' onClick={postReport}>
                  Submit
                </Button>
              </div>
            </DialogContent>
          </Dialog>
        </>
      )}

      {activeStep === 0 && role === "Seller" ? (
        <>
          <div className='DashBoardApp'>
            <h6>Your Brands</h6>
            {brandPendingStatus === true ? (
              <Card sx={{
                bgcolor: '#bcd4e6',
                borderRadius: "20px",
                marginTop: '0px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}>
                <CardContent id='card-content' sx={{ marginLeft: '20px' }}>
                  <Typography variant='body1' sx={{ fontWeight: '500', color: 'black', marginTop: '10px', marginBottom: '10px' }}>
                    Available Brand Setup : {availableBrands}
                  </Typography>
                  <Typography sx={{ color: 'black', fontSize: '14px', marginBottom: '10px' }}>Add your brand now!
                  </Typography>
                </CardContent>
                <CardContent>
                  <Button
                    startIcon={<Iconify icon="eva:plus-fill" />}
                    onClick={goToBrand}
                    variant="contained"
                    sx={{
                      backgroundColor: 'black',
                      color: 'white',
                      padding: '10px 30px',
                    }}>Add</Button>
                </CardContent>
              </Card>
            ) : (
              <></>
            )}

            {/* <Typography variant='h4' sx={{
              fontWeight: '500',
              marginTop: '10px',
              padding: '10px'

            }}>Your Brands</Typography> */}
            <Grid container spacing={2} marginTop={0}>
              {brandList.map((brand, index) => (
                <Grid item xs={12} sm={6} md={4} key={brand.id}>
                  <Card sx={{ height: '100%' }}>
                    <CardMedia
                      sx={{ height: 140 }}
                      image={brand?.thumbnail}
                      alt={brand.name}
                    // sx={{ height: 120, objectFit: 'contain', padding: 2 }}
                    />

                    <CardContent>
                      <div className='d-flex' style={{ alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
                        <Typography variant="h6" gutterBottom>{brand.name}</Typography>
                        {
                          brand?.intro_video ? (
                            <Button onClick={() => { playVideo(brand._id) }} variant='outlined' sx={{ marginBottom: '10px' }} startIcon={<Iconify icon='material-symbols:play-arrow-rounded'/>}>play Video</Button>
                          ) : (
                            <Button variant='outlined' onClick={() => handleAddVideoOpen(brand._id)} sx={{ marginBottom: '10px',padding:'5px 10px' }} startIcon={<Iconify icon="eva:plus-fill" />}>Add Video</Button>
                          )
                        }
                      </div>
                      {brand?.category_list?.map((categories, index) => (
                        <Chip label={categories?.name} variant="outlined" sx={{
                          padding: '0px 0px',
                          marginBottom: '10px',
                          // display:'flex',
                          // justifyContent:'center',
                          ":hover": {
                            backgroundColor: '#d6e2e9',

                          }

                        }} />
                      ))}
                      <Typography variant="body2" sx={{ mb: 2 }}>
                        {brand.description}
                      </Typography>
                      <Button variant="contained" size="small" fullWidth onClick={(e) => handleGoToDashboard(e, brand)}>
                        Go to DashBoard
                      </Button>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </div>
        </>
      ) : role === "Seller" ? (
        <>
          <div maxWidth="xl">
            <div className='d-flex justify-content-between'>
              <h3>{brandName}</h3>
              <Button variant='contained' size="small" sx={{ padding: '10px 20px', marginBottom: '10px', backgroundColor: 'black', color: 'white' }} onClick={handleBackToDashboard}>Back</Button>
            </div>
            <Grid container spacing={3}>

              <Grid item xs={12} md={6} lg={3}>
                <div className='dashboardCard'>
                  <p className='fs-14 mb-2 d-flex align-items-center'><Iconify style={{ marginRight: '10px' }} icon="eva:cube-outline" />Total Views</p>
                  <h4>{getAnalysisData?.views ? getAnalysisData?.views : 0}</h4>
                  <p className='fs-14 mb-0'><b>{getAnalysisData?.recent_views ? getAnalysisData?.recent_views : 0}</b> Views in last 7 days</p>
                </div>
              </Grid>

              <Grid item xs={12} md={6} lg={3}>
                <div className='dashboardCard'>
                  <p className='fs-14 mb-2 d-flex align-items-center'><Iconify style={{ marginRight: '10px' }} icon="eva:phone-outline" />Total Calls</p>
                  <h4>{getAnalysisData?.calls ? getAnalysisData?.calls : 0}</h4>
                  <p className='fs-14 mb-0'><b>{getAnalysisData?.recent_calls ? getAnalysisData?.recent_calls : 0}</b> Calls in last 7 days</p>
                </div>
              </Grid>

              <Grid item xs={12} md={6} lg={3}>
                <div className='dashboardCard'>
                  <p className='fs-14 mb-2 d-flex align-items-center'><Iconify style={{ marginRight: '10px' }} icon="eva:message-square-outline" />Total Chat</p>
                  <h4>{getAnalysisData?.chats ? getAnalysisData?.chats : 0}</h4>
                  <p className='fs-14 mb-0'><b>{getAnalysisData?.recent_chats ? getAnalysisData?.recent_chats : 0}</b> Chats in last 7 days</p>
                </div>
              </Grid>

              <Grid item xs={12} md={6} lg={3}>
                <div className='dashboardCard'>
                  <p className='fs-14 mb-2 d-flex align-items-center'><Iconify style={{ marginRight: '10px' }} icon="eva:phone-outline" />Total Callback Request</p>
                  <h4>{getAnalysisData?.callback_requests ? getAnalysisData?.callback_requests : 0}</h4>
                  <p className='fs-14 mb-0'><b>{getAnalysisData?.recent_callback_requests ? getAnalysisData?.recent_callback_requests : 0}</b> Callback in last 7 days</p>
                </div>
              </Grid>

              {role === 'Admin' ? (
                <Grid item xs={12} md={6} lg={3}>
                  <div className='dashboardCard'>
                    <p className='fs-14 mb-2 d-flex align-items-center'><Iconify style={{ marginRight: '10px' }} icon="eva:car-outline" />Total Seller</p>
                    <h4>{getAnalysisData?.sellers ? getAnalysisData?.sellers : 0}</h4>
                    <p className='fs-14 mb-0'><b>{getAnalysisData?.recent_sellers ? getAnalysisData?.recent_sellers : 0}</b> Seller in last 7 days</p>
                  </div>
                </Grid>

              ) : (
                <></>
              )}

              {role === 'Admin' ? (
                <Grid item xs={12} md={6} lg={3}>
                  <div className='dashboardCard'>
                    <p className='fs-14 mb-2 d-flex align-items-center'><Iconify style={{ marginRight: '10px' }} icon="eva:shopping-cart-outline" />Total Buyer</p>
                    <h4>{getAnalysisData?.buyers ? getAnalysisData?.buyers : 0}</h4>
                    <p className='fs-14 mb-0'><b>{getAnalysisData?.recent_buyers ? getAnalysisData?.recent_buyers : 0}</b> Buyers in last 7 days</p>
                  </div>
                </Grid>
              ) : (
                <></>
              )}

              {role === 'Admin' ? (
                <Grid item xs={12} md={6} lg={3}>
                  <div className='dashboardCard'>
                    <p className='fs-14 mb-2 d-flex align-items-center'><Iconify style={{ marginRight: '10px' }} icon="eva:grid-outline" />Total Categories</p>
                    <h4>{getAnalysisData?.categories ? getAnalysisData?.categories : 0}</h4>
                    {/* <p className='fs-14 mb-0'>{getAnalysisData?.recent_callback_requests} Callback vs 6 days before </p> */}
                  </div>
                </Grid>
              ) : (
                <></>
              )}

              {role === 'Admin' ? (
                <Grid item xs={12} md={6} lg={3}>
                  <div className='dashboardCard'>
                    <p className='fs-14 mb-2 d-flex align-items-center'><Iconify style={{ marginRight: '10px' }} icon="eva:cube-outline" />Total Products</p>
                    <h4>{getAnalysisData?.products ? getAnalysisData?.products : 0}</h4>
                    <p className='fs-14 mb-0'><b>{getAnalysisData?.recent_products ? getAnalysisData?.recent_products : 0}</b> Product in last 7 days</p>
                  </div>
                </Grid>
              ) : <></>}

              {role === 'Admin' ? (
                <></>
              ) : (

                <Grid item xs={12} md={6} lg={6}>
                  <Card>
                    <Stack className='mb-0 pt-4' paddingLeft='20px' direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                      <Typography variant="h6" style={{ fontSize: '1rem' }} className='title-color' gutterBottom>
                        History
                      </Typography>
                    </Stack>
                    <TableContainer style={{ height: "361px", overflowY: "scroll", width: "100%", padding: '20px' }}>
                      {getHistory?.map((item, index) => (
                        <div className="p-2 mb-3 profileCard">
                          <div className='row'>
                            <div className='col-lg-2'>
                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={2}
                              >
                                {item?.buyer?.profile_picture ? (
                                  <Avatar style={{ width: '60px', height: '60px' }} src={item?.buyer?.profile_picture}></Avatar>
                                ) : (
                                  <Avatar style={{ width: '60px', height: '60px' }}>
                                    {item?.buyer?.name
                                      ? item?.buyer?.name[0]
                                      : null}
                                  </Avatar>
                                )}
                              </Stack>
                            </div>
                            <div className='col-lg-6 d-flex align-items-center'>
                              <div>
                                <h6 className='d-flex align-items-center'>{item?.buyer?.name}<Tooltip title="Report" arrow><Iconify style={{ marginLeft: '10px', color: 'red' }} className='pointer' onClick={(e) => handleOpenModal(item?.buyer?._id)} icon="eva:alert-circle-outline" /></Tooltip></h6>
                                <p className='fs-14 mb-0'>{item?.buyer?.location}</p>
                              </div>
                            </div>

                            <div className='col-lg-4 d-flex align-items-center justify-content-center'>
                              <div>
                                <p className='fs-14 mb-0'>Type: <b>{item?.type}</b></p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </TableContainer>
                    <div className="d-flex flex-wrap justify-content-end m-3">
                      <FormControl variant="outlined" size="small" style={{ width: "15%" }}>
                        <Select
                          labelId="limit-label"
                          id="limit-select"
                          value={limit}
                          onChange={handleLimitChange}
                        >
                          <MenuItem value={10}>10</MenuItem>
                          <MenuItem value={20}>20</MenuItem>
                          <MenuItem value={30}>30</MenuItem>
                          <MenuItem value={TotalItems}>All</MenuItem>
                        </Select>
                      </FormControl>
                      <Button onClick={handlePrevPage} disabled={currentPage === 1}>
                        <Iconify icon={"grommet-icons:previous"} />
                      </Button>
                      <Button
                        onClick={handleNextPage}
                        disabled={currentPage === totalPages}
                      >
                        <Iconify icon={"grommet-icons:next"} />
                      </Button>
                    </div>
                  </Card>
                </Grid>
              )}

              {role === 'Admin' ? (
                <></>
              ) : (
                <Grid item xs={12} md={6} lg={6}>
                  <Card>
                    <Stack className='mb-0 pt-4' paddingLeft='20px' direction="row" alignItems="center" justifyContent="space-between" mb={2}>
                      <Typography variant="h6" className='title-color' style={{ fontSize: '1rem' }} gutterBottom>
                        Call Requests
                      </Typography>
                    </Stack>
                    <TableContainer style={{ height: "361px", overflowY: "scroll", width: "100%", padding: '20px' }}>
                      {callRequest?.map((item, index) => (
                        <div className="p-2 mb-3 profileCard">
                          <div className='row'>
                            <div className='col-lg-2'>
                              <Stack
                                direction="row"
                                alignItems="center"
                                spacing={2}
                              >
                                {item?.buyer?.profile_picture ? (
                                  <Avatar style={{ width: '60px', height: '60px' }} src={item?.buyer?.profile_picture}></Avatar>
                                ) : (
                                  <Avatar style={{ width: '60px', height: '60px' }}>
                                    {item?.buyer?.name
                                      ? item?.buyer?.name[0]
                                      : null}
                                  </Avatar>
                                )}
                              </Stack>
                            </div>
                            <div className='col-lg-5 d-flex align-items-center'>
                              <div>
                                <h6 className='d-flex align-items-center'>{item?.buyer?.name ? item?.buyer?.name : 'Name Not Available'}<Tooltip title="Report" arrow><Iconify style={{ marginLeft: '10px', color: 'red' }} onClick={(e) => handleOpenModal(item?.buyer?._id)} className='pointer' icon="eva:alert-circle-outline" /></Tooltip></h6>
                                <p className='fs-14 mb-0'>{item?.buyer?.location ? item?.buyer?.location : 'Location Not Available'}</p>
                              </div>
                            </div>

                            <div className='col-lg-5 d-flex align-items-center justify-content-center'>
                              <div>
                                <a href={`tel:${item?.buyer?.phone}`} style={{ textDecoration: 'none', color: '#212B36' }}>
                                  <p className='fs-14 mb-2'><Iconify style={{ marginRight: '12px' }} icon={"eva:phone-outline"} /><b> {item?.buyer?.phone ? item?.buyer?.phone : 'Not Available'}</b></p>
                                </a>
                                <a
                                  href={`https://wa.me/${item?.buyer?.whatsapp}`}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{ textDecoration: 'none', color: '#212B36' }}
                                >
                                  <p className="fs-14 d-flex align-items-center mb-0"><img style={{ marginRight: '14px', width: '11%' }} src={whatsappIcon} /><b>{item?.buyer?.whatsapp ? item?.buyer?.whatsapp : 'Not Available'}</b></p>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </TableContainer>
                    <div className="d-flex flex-wrap justify-content-end m-3">
                      <FormControl variant="outlined" size="small" style={{ width: "15%" }}>
                        <Select
                          labelId="limit-label"
                          id="limit-select"
                          value={limitRequest}
                          onChange={handleLimitChangeRequest}
                        >
                          <MenuItem value={10}>10</MenuItem>
                          <MenuItem value={20}>20</MenuItem>
                          <MenuItem value={30}>30</MenuItem>
                          <MenuItem value={TotalItemsRequest}>All</MenuItem>
                        </Select>
                      </FormControl>
                      <Button onClick={handlePrevPageRequest} disabled={currentPageRequest === 1}>
                        <Iconify icon={"grommet-icons:previous"} />
                      </Button>
                      <Button
                        onClick={handleNextPageRequest}
                        disabled={currentPageRequest === totalPagesRequest}
                      >
                        <Iconify icon={"grommet-icons:next"} />
                      </Button>
                    </div>
                  </Card>
                </Grid>
              )}


              {/* <Grid item xs={12} md={6} lg={6}>
            <AppOrderTimeline
              title="Order Timeline"
              list={[...Array(5)].map((_, index) => ({
                id: faker.datatype.uuid(),
                title: [
                  '1983, orders, $4220',
                  '12 Invoices have been paid',
                  'Order #37745 from September',
                  'New order placed #XF-2356',
                  'New order placed #XF-2346',
                ][index],
                type: `order${index + 1}`,
                time: faker.date.past(),
              }))}
            />
          </Grid> */}
            </Grid>
          </div>

          <Dialog open={openModal} onClose={handleClose} maxWidth="sm" fullWidth>
            <DialogTitle>Report Buyer</DialogTitle>
            <DialogContent>
              <Grid item xs={12} className='mt-3'>
                <TextField
                  className="w-100"
                  id="outlined-basic"
                  value={report}
                  onChange={(e) => setReport(e.target.value)}
                  label="Report *"
                  variant="outlined"
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Grid>
              <div className='mt-4 d-flex justify-content-end'>
                <Button variant="contained" className='Button' onClick={postReport}>
                  Submit
                </Button>
              </div>
            </DialogContent>
          </Dialog>
        </>
      ) : null}
      <Dialog open={video} maxWidth="md" fullWidth>
        <DialogTitle>
          <div className="d-flex justify-content-between">
            <DialogTitle>Brand Video</DialogTitle>
            <Iconify icon='material-symbols:close-rounded' sx={{ margin: '12px' , cursor:'pointer'}} onClick={handleCloseVideo} />
          </div>
          <DialogContent sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
            <video src={previewVideo} style={{ width: '80%', height: '25%', objectFit: 'cover' }} autoPlay muted loop></video>
          </DialogContent>
        </DialogTitle>
      </Dialog>
      <Dialog open={addVideoOpen} onClose={handleAddVideoClose} maxWidth="md" fullWidth>
        <div className="d-flex justify-content-between">
          <DialogTitle>Upload Brand Intro Video</DialogTitle>
          <Iconify icon='material-symbols:close-rounded' sx={{ margin: '12px' }} onClick={handleAddVideoClose} />
        </div>
        <DialogContent>
          <Paper elevation={3} sx={{ padding: 2, marginTop: 0, borderRadius: 2 }}>
            <form>
              <Box display="flex" flexDirection="column" gap={2} sx={{ marginTop: 1 }}>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <div style={{ textAlign: "center", padding: '12px', border: '1px solid #e3e3e3', borderRadius: '10px' }}>
                      <input
                        type="file"
                        accept="video/*"
                        id="videoInput"
                        style={{ display: "none" }}
                        onChange={handleVideoChange}
                      />
                      <label htmlFor="videoInput">
                        {previewUploadedVideo ? (
                          <video
                            src={previewUploadedVideo}
                            controls
                            style={{
                              width: "300px",
                              height: "220px",
                              objectFit: "contain",
                              cursor: "pointer",
                              borderRadius: "10px",
                            }}
                          />
                        ) : (
                          <div style={{
                            width: "300px",
                            height: "230px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#f0f0f0",
                            borderRadius: "10px",
                            cursor: "pointer"
                          }}>
                            <p style={{ fontSize: '14px', color: '#666' }}>Click to upload video</p>
                          </div>
                        )}
                        <p className='mb-0' style={{ fontSize: '12px' }}>Upload video</p>
                      </label>
                    </div>
                  </Grid>
                </Grid>
                <div className='mt-4 d-flex justify-content-end'>
                  <Button variant="contained" type="submit" onClick={handleSubmit}>
                    Submit
                  </Button>
                </div>
              </Box>
            </form>
          </Paper>
        </DialogContent>
      </Dialog>
    </>
  );
}
